import React, { useState } from 'react';
import './QuizCategories.css';

const QuizCategories = () => {
    const [currentSubject, setCurrentSubject] = useState('math');

    const subjects = {
        math: [
            { topic: "Algebra", difficulty: 75, struggleRate: 25 },
            { topic: "Geometry", difficulty: 65, struggleRate: 35 },
            { topic: "Calculus", difficulty: 85, struggleRate: 45 },
            { topic: "Statistics", difficulty: 60, struggleRate: 30 }
        ],
        english: [
            { topic: "Grammar", difficulty: 70, struggleRate: 30 },
            { topic: "Vocabulary", difficulty: 65, struggleRate: 35 },
            { topic: "Reading", difficulty: 75, struggleRate: 25 },
            { topic: "Writing", difficulty: 80, struggleRate: 40 }
        ],
        russian: [
            { topic: "Grammar", difficulty: 80, struggleRate: 40 },
            { topic: "Vocabulary", difficulty: 75, struggleRate: 35 },
            { topic: "Reading", difficulty: 70, struggleRate: 30 },
            { topic: "Speaking", difficulty: 85, struggleRate: 45 }
        ]
    };

    return (
        <section className="quiz-categories">
            <div className="container">
                <h2>Explore Our Quiz Categories</h2>
                <div className="category-tabs">
                    <button
                        className={`tab ${currentSubject === 'math' ? 'active' : ''}`}
                        onClick={() => setCurrentSubject('math')}
                    >
                        Math
                    </button>
                    <button
                        className={`tab ${currentSubject === 'english' ? 'active' : ''}`}
                        onClick={() => setCurrentSubject('english')}
                    >
                        English
                    </button>
                    <button
                        className={`tab ${currentSubject === 'russian' ? 'active' : ''}`}
                        onClick={() => setCurrentSubject('russian')}
                    >
                        Russian
                    </button>
                </div>
                <div className="category-grid">
                    {subjects[currentSubject].map((topic, index) => (
                        <div key={index} className="category-card">
                            <h3>{topic.topic}</h3>
                            <div className="difficulty-meter">
                                <div 
                                    className="difficulty-fill"
                                    style={{ width: `${topic.difficulty}%` }}
                                />
                            </div>
                            <div className="struggle-rate">
                                <span className="struggle-icon">⚠️</span>
                                {topic.struggleRate}% of students struggle
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default QuizCategories; 